import Papa from 'papaparse';

export function parseCsvFile(
  file: File
): Promise<{ headers: string[]; rows: Record<string, string>[] }> {
  return new Promise((resolve, reject) => {
    Papa.parse<Record<string, string>>(file, {
      header: true,
      skipEmptyLines: 'greedy',
      transformHeader: (h) => String(h).replace(/^\ufeff/, '').trim(),
      complete: (result) => {
        const rows = (result.data || []).filter((row) =>
          Object.values(row).some((v) => String(v ?? '').trim() !== '')
        );
        const headers =
          result.meta.fields?.filter(Boolean) ??
          (rows[0] ? Object.keys(rows[0]) : []);
        resolve({ headers, rows });
      },
      error: (err) => reject(err),
    });
  });
}
